import { render, staticRenderFns } from "./DeviceRegister.vue?vue&type=template&id=cbfddbc2&scoped=true"
import script from "./DeviceRegister.vue?vue&type=script&lang=js"
export * from "./DeviceRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfddbc2",
  null
  
)

export default component.exports